<template>
  <div>
    <b-card no-body>
      <b-card-header>
        <b-card-title>{{ title }}</b-card-title>
        <b-card-title class="text-primary">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="secondary"
            class="btn-icon"
            size="sm"
            :to="{ name: 'koreksiCleansing' }"
          >
            <feather-icon icon="ArrowLeftIcon" />
          </b-button>
        </b-card-title>
      </b-card-header>

      <b-card-body>
        <b-form
          v-if="routeName == 'koreksiCleansingTambah'"
          class="needs-validation"
          @submit.prevent="submitCari"
        >
          <b-form-row>
            <b-col
              md="10"
              offset-md="1"
            >
              <b-form-group
                label="Status"
                label-for="status"
              >
                <b-form-select
                  id="status"
                  v-model="status"
                  :options="dataStatus"
                  @change="changeStatus"
                />
              </b-form-group>
              <b-form-group
                label="Wilayah"
                label-for="wilayah"
              >
                <b-form-select
                  id="wilayah"
                  v-model="wilayah"
                  :options="dataWilayah"
                  @change="changeWilayah"
                />
              </b-form-group>
              <b-form-group
                label="PD/UPD"
                label-for="pdUpd"
              >
                <b-overlay
                  :show="isLoadPdUpd"
                  variant="light"
                  opacity="0.85"
                  blur="2px"
                  rounded="sm"
                >
                  <v-select
                    id="kolok"
                    v-model="pdUpd"
                    label="text"
                    :options="dataPdUpd"
                    @input="inputPdUpd"
                  />
                </b-overlay>
              </b-form-group>
              <b-form-group
                label="Pencarian"
                label-for="register"
              >
                <b-overlay
                  :show="isLoadRegister"
                  variant="light"
                  opacity="0.85"
                  blur="2px"
                  rounded="sm"
                >
                  <v-select
                    id="kolok"
                    v-model="register"
                    label="text"
                    :options="dataRegister"
                    @input="inputRegister"
                    @search="searchRegister"
                  />
                </b-overlay>
              </b-form-group>
            </b-col>
          </b-form-row>
        </b-form>
        <b-form
          v-if="isShowForm"
          class="needs-validation"
          @submit.prevent="submitForm"
        >
          <b-overlay
            :show="isLoadFormVal"
            variant="light"
            opacity="0.85"
            blur="2px"
            rounded="sm"
          >
            <b-form-row>
              <b-col md="6">
                <h6 class="font-weight-bolder">
                  PB
                </h6>
                <KodeLokasi :kolok="rKolok" />
                <Kib :kib="rKib" />
                <KodeBarang :kobar="rKobar" />
                <NamaBarang :nama-barang="rNabar" />
                <KodeRegisterBarang :kode-register-barang="rKodeRegisterBarang" />
                <NilaiPerolehan :nilai-perolehan="rNilaiPerolehan" />
                <TanggalPerolehan :tanggal-perolehan="rTahunPerolehan" />
                <Keberadaan
                  v-if="
                    (rKeberadaan == '1' ||
                      (rAlasanTidakAdaP != '0' &&
                        rAlasanTidakAdaP != '1' &&
                        rAlasanTidakAdaP != '2')) &&
                      (rKeberadaan == '1' ||
                        rAlasanTidakAdaP == '0' ||
                        rAlasanTidakAdaP == '1' ||
                        rAlasanTidakAdaP == '2' ||
                        (rAlasanTidakAda != '13' &&
                          rAlasanTidakAda != '14' &&
                          rAlasanTidakAda != '11') ||
                        rAlasanTidakAda == 5)
                  "
                  :keberadaan="rKeberadaan"
                  :keterangan-beton="rKeteranganBeton"
                  :biaya2beban="
                    rAlasanTidakAdaP == '0' ||
                      rAlasanTidakAdaP == '1' ||
                      rAlasanTidakAdaP == '2'
                      ? '1'
                      : '0'
                  "
                  :alasan-tidak-ada-barang="
                    rAlasanTidakAda == '13'
                      ? '0'
                      : rAlasanTidakAda == '14'
                        ? '1'
                        : rAlasanTidakAda == '11'
                          ? '2'
                          : '3'
                  "
                  :sebab-lain="rAlasanTidakAda"
                >
                  <template v-slot:barat>
                    <b-form-input
                      v-model="rTanda2batasTanahBarat"
                      disabled
                    />
                  </template>
                  <template v-slot:utara>
                    <b-form-input
                      v-model="rTanda2batasTanahUtara"
                      disabled
                    />
                  </template>
                  <template v-slot:selatan>
                    <b-form-input
                      v-model="rTanda2batasTanahSelatan"
                      disabled
                    />
                  </template>
                  <template v-slot:timur>
                    <b-form-input
                      v-model="rTanda2batasTanahTimur"
                      disabled
                    />
                  </template>
                  <template v-slot:keteranganBetonSebutkan>
                    <b-form-input
                      v-model="rKeteranganBetonSebutkan"
                      disabled
                    />
                  </template>
                  <template v-slot:peruntukkanPenggunaanBmd>
                    <b-form-input
                      v-model="rPeruntukkanPenggunaanBmd"
                      disabled
                    />
                  </template>
                  <template v-slot:sebabLain>
                    <b-form-input
                      v-model="rSebabLain"
                      disabled
                    />
                  </template>
                </Keberadaan>
                <V2Ukuran
                  v-if="rKesesuaianUkuran != 1"
                  :ukuran="rUkuran"
                  :satuan="rSatuan"
                  :kesesuaian-ukuran="rKesesuaianUkuran"
                  :satuan-seharusnya="rSatuanSeharusnya"
                >
                  <b-form-input
                    v-model="rUkuranSeharusnya"
                    disabled
                  />
                </V2Ukuran>
                <V3NamaSpesifikasiBarang>
                  <b-form-input
                    v-model="rNamaSpesifikasiBarang"
                    disabled
                  />
                </V3NamaSpesifikasiBarang>
                <V4Alamat
                  :alamat="rAlamat"
                  :provinsi="rProvinsi"
                  :data-provinsi="dataProvinsi"
                  :kab-kota="rKabKota"
                  :data-kab-kota="dataKabKota"
                  :kecamatan="rKecamatan"
                  :data-kecamatan="dataKecamatan"
                  :kelurahan="rKelurahan"
                  :data-kelurahan="dataKelurahan"
                  :kode-pos="rKodePos"
                >
                  <template v-slot:jalan>
                    <b-form-input
                      v-model="rJalan"
                      disabled
                    />
                  </template>
                  <template v-slot:noAlamat>
                    <b-form-input
                      v-model="rNoAlamat"
                      disabled
                    />
                  </template>
                  <template v-slot:rt>
                    <b-form-input
                      v-model="rRt"
                      disabled
                    />
                  </template>
                  <template v-slot:rw>
                    <b-form-input
                      v-model="rRw"
                      disabled
                    />
                  </template>
                </V4Alamat>
                <V5GedungdanBangunanDiatasTanahMilik
                  v-if="
                    rGedungBangunanTanahMilik != 1 ||
                      rIsGedungBangunanTanahMilikTercatat != 1
                  "
                  :gedung-bangunan-tanah-milik="rGedungBangunanTanahMilik"
                  :is-gedung-bangunan-tanah-milik-tercatat="
                    rIsGedungBangunanTanahMilikTercatat
                  "
                  :gedung-bangunan-tanah-milik-pd-ukpd="
                    rGedungBangunanTanahMilikPdUkpd.value
                  "
                  :data-pd-ukpd="dataPdUkpd"
                  :gedung-bangunan-tanah-milik-kobar="
                    rGedungBangunanTanahMilikKobar.text
                  "
                  :data-gedung-bangunan-tanah-milik-kobar="
                    dataGedungBangunanTanahMilikKobar
                  "
                  :gedung-bangunan-tanah-milik-register="
                    rGedungBangunanTanahMilikRegister.value
                  "
                  :data-gedung-bangunan-tanah-milik-register="
                    dataGedungBangunanTanahMilikRegister
                  "
                >
                  <template v-slot:gedungBangunanTanahMilikKeterangan>
                    <b-form-input
                      v-model="rGedungBangunanTanahMilikKeterangan"
                      disabled
                    />
                  </template>
                  <template v-slot:gedungBangunanTanahMilikSebutkan>
                    <b-form-input
                      v-model="rGedungBangunanTanahMilikSebutkan"
                      disabled
                    />
                  </template>
                </V5GedungdanBangunanDiatasTanahMilik>
                <V6IndikasiTercatatGanda
                  v-if="
                    rIsIndikasiGanda == 1 &&
                      (rIndikasiGandaDengan === '1' ||
                        rIndikasiGandaDengan === '2')
                  "
                  :is-indikasi-ganda="rIsIndikasiGanda"
                  :indikasi-ganda-dengan="rIndikasiGandaDengan"
                >
                  <b-form-input
                    v-model="rIndikasiGandaSebutkan"
                    disabled
                  />
                </V6IndikasiTercatatGanda>
                <V7IndikasiTercatatGabungan
                  v-if="rIndikasiGabungan == '1'"
                  :indikasi-gabungan="rIndikasiGabungan"
                >
                  <b-form-input
                    v-model="rIndikasiGabunganKeterangan"
                    disabled
                  />
                </V7IndikasiTercatatGabungan>
                <V8SkPenggunaan
                  v-if="rSkPenggunaan === '1'"
                  :sk-penggunaan="rSkPenggunaan"
                >
                  <template v-slot:nomorSkPenggunaan>
                    <b-form-input
                      v-model="rNomorSkPenggunaan"
                      disabled
                    />
                  </template>
                  <template v-slot:tahunSkPenggunaan>
                    <b-form-input
                      v-model="rTahunSkPenggunaan"
                      disabled
                    />
                  </template>
                </V8SkPenggunaan>
                <V9Penggunaan
                  v-if="rPenggunaan != '1'"
                  :penggunaan="rPenggunaan"
                >
                  <template>
                    <b-form-input
                      v-if="rPenggunaan === '2'"
                      v-model="rDigunakanUntuk[0].value"
                      disabled
                    />
                    <div
                      v-for="(item, index) of rPdUkpd"
                      v-else-if="rPenggunaan === '3'"
                      :key="index"
                    >
                      <b-form-group
                        label="PD/UKPD"
                        label-for="pdUkpd"
                      >
                        <b-form-select
                          v-model="item.value"
                          :options="dataPdUkpd"
                          disabled
                        />
                      </b-form-group>

                      <b-col
                        cols="11"
                        offset-md="1"
                        class="mt-1 pr-0"
                      >
                        <b-form-group
                          label="Digunakan Untuk"
                          label-for="digunakanUntuk"
                        >
                          <b-form-input
                            v-model="rDigunakanUntuk[index].value"
                            disabled
                          />
                        </b-form-group>
                      </b-col>
                    </div>
                    <div v-else-if="rPenggunaan === '4'">
                      <b-form-checkbox
                        v-model="rDigunakanBersama"
                        disabled
                        value="1"
                      >PD/UKPD Lain</b-form-checkbox>
                      <b-col
                        v-if="rDigunakanBersama.includes('1')"
                        cols="11"
                        offset-md="1"
                        class="mt-1 pr-0"
                      >
                        <div
                          v-for="(item, index) of rPdUkpd"
                          :key="index"
                        >
                          <b-form-group
                            label="PD/UKPD"
                            label-for="pdUkpd"
                          >
                            <b-form-select
                              v-model="item.value.value"
                              :options="dataPdUkpd"
                              disabled
                            />
                          </b-form-group>
                          <b-col
                            cols="11"
                            offset-md="1"
                            class="mt-1 pr-0"
                          >
                            <b-form-group
                              label="Digunakan Untuk"
                              label-for="digunakanUntuk"
                            >
                              <b-form-input
                                id="digunakanUntuk"
                                v-model="rDigunakanUntuk[index].value"
                                disabled
                              />
                            </b-form-group>
                          </b-col>
                        </div>
                      </b-col>
                      <b-form-checkbox
                        v-model="rDigunakanBersama"
                        disabled
                        value="0"
                      >Instansi / Pihak Lain</b-form-checkbox>
                      <b-col
                        v-if="rDigunakanBersama.includes('0')"
                        cols="11"
                        offset-md="1"
                        class="mt-1 pr-0"
                      >
                        <div
                          v-for="(item, indexx) of rPemanfaat"
                          :key="indexx + 'i'"
                        >
                          <b-form-group
                            label="Pemanfaat"
                            label-for="pemanfaat"
                          >
                            <b-form-select
                              v-model="item.value"
                              :options="dataPemanfaat"
                              disabled
                            />
                          </b-form-group>
                          <b-col
                            cols="11"
                            offset-md="1"
                            class="mt-1 pr-0"
                          >
                            <div v-if="rPemanfaat[indexx].value === '1' || rPemanfaat[indexx].value === '2'">
                              <b-form-group
                                label="Nama Pemanfaat"
                                label-for="namaPemanfaat"
                              >
                                <b-form-input
                                  v-model="rPemanfaat[indexx].namaPemanfaat"
                                  disabled
                                />
                              </b-form-group>
                              <b-form-group
                                label="Dasar Penggunaan"
                                label-for="dasarPenggunaan"
                              >
                                <b-form-radio
                                  v-model="rPemanfaat[indexx].dasarPenggunaan"
                                  disabled
                                  value="1"
                                >Ada Pinjam Pakai</b-form-radio>
                                <b-form-radio
                                  v-model="rPemanfaat[indexx].dasarPenggunaan"
                                  disabled
                                  value="0"
                                >Tidak Ada Pinjam Pakai</b-form-radio>
                              </b-form-group>
                            </div>

                            <div v-if="rPemanfaat[indexx].value === '3'">
                              <b-form-group
                                label="Nama Pemanfaat"
                                label-for="namaPemanfaat"
                              >
                                <b-form-input
                                  v-model="rPemanfaat[indexx].namaPemanfaat"
                                  disabled
                                />
                              </b-form-group>
                              <b-form-group label="Dasar Penggunaan">
                                <b-form-radio
                                  v-model="rPemanfaat[indexx].dasarPenggunaan"
                                  disabled
                                  value="1"
                                >Ada Dasar Penggunaan</b-form-radio>

                                <b-col
                                  v-if="
                                    rPemanfaat[indexx].dasarPenggunaan === '1'
                                  "
                                  cols="11"
                                  offset-md="1"
                                >
                                  <b-form-radio
                                    v-model="
                                      rPemanfaat[indexx].dasarPenggunaanTipe
                                    "
                                    disabled
                                    value="6"
                                  >Sewa</b-form-radio>
                                  <b-form-radio
                                    v-model="
                                      rPemanfaat[indexx].dasarPenggunaanTipe
                                    "
                                    disabled
                                    value="5"
                                  >Pinjam Pakai</b-form-radio>
                                  <b-form-radio
                                    v-model="
                                      rPemanfaat[indexx].dasarPenggunaanTipe
                                    "
                                    disabled
                                    value="3"
                                  >Bangun Guna Serah</b-form-radio>
                                  <b-form-radio
                                    v-model="
                                      rPemanfaat[indexx].dasarPenggunaanTipe
                                    "
                                    disabled
                                    value="4"
                                  >Bangun Serah Guna</b-form-radio>
                                  <b-form-radio
                                    v-model="
                                      rPemanfaat[indexx].dasarPenggunaanTipe
                                    "
                                    disabled
                                    value="7"
                                  >KSP (Kerjasama Pemanfaatan)</b-form-radio>
                                  <b-form-radio
                                    v-model="
                                      rPemanfaat[indexx].dasarPenggunaanTipe
                                    "
                                    disabled
                                    value="1"
                                  >KSPI</b-form-radio>
                                </b-col>

                                <b-form-radio
                                  v-model="rPemanfaat[indexx].dasarPenggunaan"
                                  disabled
                                  value="0"
                                >Tidak Ada Dasar Penggunaan</b-form-radio>
                              </b-form-group>
                            </div>
                          </b-col>
                        </div>
                      </b-col>
                    </div>
                    <div
                      v-for="(item, indexx) of rPemanfaat"
                      v-else-if="rPenggunaan === '5'"
                      :key="indexx + 'i'"
                    >
                      <b-form-group
                        label="Pemanfaat"
                        label-for="pemanfaat"
                      >
                        <b-form-select
                          v-model="item.value"
                          :options="dataPemanfaat"
                          disabled
                        />
                      </b-form-group>
                      <b-col
                        cols="11"
                        offset-md="1"
                        class="mt-1 pr-0"
                      >
                        <div v-if="rPemanfaat[indexx].value === '1' || rPemanfaat[indexx].value === '2'">
                          <b-form-group
                            label="Nama Pemanfaat"
                            label-for="namaPemanfaat"
                          >
                            <b-form-input
                              v-model="rPemanfaat[indexx].namaPemanfaat"
                              disabled
                            />
                          </b-form-group>
                          <b-form-group
                            label="Dasar Penggunaan"
                            label-for="dasarPenggunaan"
                          >
                            <b-form-radio
                              v-model="rPemanfaat[indexx].dasarPenggunaan"
                              disabled
                              value="1"
                            >Ada Pinjam Pakai</b-form-radio>
                            <b-form-radio
                              v-model="rPemanfaat[indexx].dasarPenggunaan"
                              disabled
                              value="0"
                            >Tidak Ada Pinjam Pakai</b-form-radio>
                          </b-form-group>
                        </div>

                        <div v-if="rPemanfaat[indexx].value === '3'">
                          <b-form-group
                            label="Nama Pemanfaat"
                            label-for="namaPemanfaat"
                          >
                            <b-form-input
                              v-model="rPemanfaat[indexx].namaPemanfaat"
                              disabled
                            />
                          </b-form-group>
                          <b-form-group label="Dasar Penggunaan">
                            <b-form-radio
                              v-model="rPemanfaat[indexx].dasarPenggunaan"
                              disabled
                              value="1"
                            >Ada Dasar Penggunaan</b-form-radio>

                            <b-col
                              v-if="rPemanfaat[indexx].dasarPenggunaan === '1'"
                              cols="11"
                              offset-md="1"
                            >
                              <b-form-radio
                                v-model="rPemanfaat[indexx].dasarPenggunaanTipe"
                                disabled
                                value="6"
                              >Sewa</b-form-radio>
                              <b-form-radio
                                v-model="rPemanfaat[indexx].dasarPenggunaanTipe"
                                disabled
                                value="5"
                              >Pinjam Pakai</b-form-radio>
                              <b-form-radio
                                v-model="rPemanfaat[indexx].dasarPenggunaanTipe"
                                disabled
                                value="3"
                              >Bangun Guna Serah</b-form-radio>
                              <b-form-radio
                                v-model="rPemanfaat[indexx].dasarPenggunaanTipe"
                                disabled
                                value="4"
                              >Bangun Serah Guna</b-form-radio>
                              <b-form-radio
                                v-model="rPemanfaat[indexx].dasarPenggunaanTipe"
                                disabled
                                value="7"
                              >KSP (Kerjasama Pemanfaatan)</b-form-radio>
                              <b-form-radio
                                v-model="rPemanfaat[indexx].dasarPenggunaanTipe"
                                disabled
                                value="1"
                              >KSPI</b-form-radio>
                            </b-col>

                            <b-form-radio
                              v-model="rPemanfaat[indexx].dasarPenggunaan"
                              disabled
                              value="0"
                            >Tidak Ada Dasar Penggunaan</b-form-radio>
                          </b-form-group>
                        </div>
                      </b-col>
                    </div>
                  </template>
                </V9Penggunaan>
                <V11PotensiPemanfaatan
                  v-if="
                    rIsLantaiDigunakan == 1 ||
                      (rIsAtapBeton == 1 && rIsAtapBetonIsDigunakan == 1) ||
                      (rIsBasement == 1 && rIsBasementIsDigunakan == 1) ||
                      (rIsHalamanUtama == 1 && rIsHalamanUtamaIsDigunakan == 1)
                  "
                  :is-lantai-digunakan="rIsLantaiDigunakan"
                  :jumlah-seluruh-lantai="rJumlahSeluruhLantai"
                  :jumlah-lantai-digunakan="jumlahLantaiDigunakan"
                  :is-atap-beton="rIsAtapBeton"
                  :is-atap-beton-is-digunakan="rIsAtapBetonIsDigunakan"
                  :is-basement="rIsBasement"
                  :is-basement-is-digunakan="rIsBasementIsDigunakan"
                  :is-halaman-utama="rIsHalamanUtama"
                  :is-halaman-utama-is-digunakan="rIsHalamanUtamaIsDigunakan"
                >
                  <template v-slot:jumlahLantaiTidakDigunakan>
                    <b-form-input
                      v-model="rJumlahLantaiTidakDigunakan"
                      disabled
                    />
                  </template>
                  <template v-slot:atapBetonDigunakan>
                    <b-form-input
                      v-model="rAtapBetonDigunakan"
                      disabled
                    />
                  </template>
                  <template v-slot:basementDigunakan>
                    <b-form-input
                      v-model="rBasementDigunakan"
                      disabled
                    />
                  </template>
                  <template v-slot:halamanUtamaDigunakan>
                    <b-form-input
                      v-model="rHalamanUtamaDigunakan"
                      disabled
                    />
                  </template>
                </V11PotensiPemanfaatan>
                <V13PenguasaanFisik
                  v-if="
                    (rPengamananFisik === '1' && rFisikDikuasai === '0') ||
                      rPengamananFisik === '0'
                  "
                  :pengamanan-fisik="rPengamananFisik"
                  :fisik-dikuasai="rFisikDikuasai"
                >
                  <template v-slot:fisikDikuasaiSebutkan>
                    <b-form-input
                      v-model="rFisikDikuasaiSebutkan"
                      disabled
                    />
                  </template>
                  <template v-slot:fisikTidakDikuasaiSebutkan>
                    <b-form-input
                      v-model="rFisikTidakDikuasaiSebutkan"
                      disabled
                    />
                  </template>
                </V13PenguasaanFisik>
              </b-col>
              <b-col md="6">
                <h6 class="font-weight-bolder">
                  PUA
                </h6>
                <KodeLokasi :kolok="rKolok" />
                <Kib :kib="rKib" />
                <KodeBarang :kobar="rKobar" />
                <NamaBarang :nama-barang="rNabar" />
                <KodeRegisterBarang :kode-register-barang="rKodeRegisterBarang" />
                <NilaiPerolehan :nilai-perolehan="rNilaiPerolehan" />
                <TanggalPerolehan :tanggal-perolehan="rTahunPerolehan" />
                <Keberadaan
                  v-if="
                    (rKeberadaan == '1' ||
                      (rAlasanTidakAdaP != '0' &&
                        rAlasanTidakAdaP != '1' &&
                        rAlasanTidakAdaP != '2')) &&
                      (rKeberadaan == '1' ||
                        rAlasanTidakAdaP == '0' ||
                        rAlasanTidakAdaP == '1' ||
                        rAlasanTidakAdaP == '2' ||
                        (rAlasanTidakAda != '13' &&
                          rAlasanTidakAda != '14' &&
                          rAlasanTidakAda != '11') ||
                        rAlasanTidakAda == 5)
                  "
                  :keberadaan="rKeberadaan"
                  :keterangan-beton="rKeteranganBeton"
                  :biaya2beban="
                    rAlasanTidakAdaP == '0' ||
                      rAlasanTidakAdaP == '1' ||
                      rAlasanTidakAdaP == '2'
                      ? '1'
                      : '0'
                  "
                  :alasan-tidak-ada-barang="
                    rAlasanTidakAda == '13'
                      ? '0'
                      : rAlasanTidakAda == '14'
                        ? '1'
                        : rAlasanTidakAda == '11'
                          ? '2'
                          : '3'
                  "
                  :sebab-lain="rAlasanTidakAda"
                >
                  <template v-slot:barat>
                    <b-form-input v-model="tanda2BatasTanahBarat" />
                  </template>
                  <template v-slot:utara>
                    <b-form-input v-model="tanda2BatasTanahUtara" />
                  </template>
                  <template v-slot:selatan>
                    <b-form-input v-model="tanda2BatasTanahSelatan" />
                  </template>
                  <template v-slot:timur>
                    <b-form-input v-model="tanda2BatasTanahTimur" />
                  </template>
                  <template v-slot:keteranganBetonSebutkan>
                    <b-form-input v-model="keteranganBetonSebutkan" />
                  </template>
                  <template v-slot:peruntukkanPenggunaanBmd>
                    <b-form-input v-model="peruntukkanPenggunaanBmd" />
                  </template>
                  <template v-slot:sebabLain>
                    <b-form-input v-model="sebabLain" />
                  </template>
                </Keberadaan>
                <V2Ukuran
                  v-if="rKesesuaianUkuran != 1"
                  :ukuran="rUkuran"
                  :satuan="rSatuan"
                  :kesesuaian-ukuran="rKesesuaianUkuran"
                  :satuan-seharusnya="rSatuanSeharusnya"
                >
                  <cleave
                    v-model="ukuranSeharusnya"
                    class="form-control"
                    :options="{
                      ...ruleAngka,
                      numeralDecimalScale: 20,
                    }"
                  />
                </V2Ukuran>
                <V3NamaSpesifikasiBarang>
                  <b-form-input v-model="namaSpesifikasiBarang" />
                </V3NamaSpesifikasiBarang>
                <V4Alamat
                  :alamat="rAlamat"
                  :provinsi="rProvinsi"
                  :data-provinsi="dataProvinsi"
                  :kab-kota="rKabKota"
                  :data-kab-kota="dataKabKota"
                  :kecamatan="rKecamatan"
                  :data-kecamatan="dataKecamatan"
                  :kelurahan="rKelurahan"
                  :data-kelurahan="dataKelurahan"
                  :kode-pos="rKodePos"
                >
                  <template v-slot:jalan>
                    <b-form-input v-model="jalan" />
                  </template>
                  <template v-slot:noAlamat>
                    <b-form-input v-model="noAlamat" />
                  </template>
                  <template v-slot:rt>
                    <b-form-input
                      v-model="rt"
                      maxlength="3"
                      minlength="3"
                      @keydown="changeIntOnly"
                    />
                  </template>
                  <template v-slot:rw>
                    <b-form-input
                      v-model="rw"
                      maxlength="3"
                      minlength="3"
                      @keydown="changeIntOnly"
                    />
                  </template>
                </V4Alamat>
                <V5GedungdanBangunanDiatasTanahMilik
                  v-if="
                    rGedungBangunanTanahMilik != 1 ||
                      rIsGedungBangunanTanahMilikTercatat != 1
                  "
                  :gedung-bangunan-tanah-milik="rGedungBangunanTanahMilik"
                  :is-gedung-bangunan-tanah-milik-tercatat="
                    rIsGedungBangunanTanahMilikTercatat
                  "
                  :gedung-bangunan-tanah-milik-pd-ukpd="
                    rGedungBangunanTanahMilikPdUkpd.value
                  "
                  :data-pd-ukpd="dataPdUkpd"
                  :gedung-bangunan-tanah-milik-kobar="
                    rGedungBangunanTanahMilikKobar.text
                  "
                  :data-gedung-bangunan-tanah-milik-kobar="
                    dataGedungBangunanTanahMilikKobar
                  "
                  :gedung-bangunan-tanah-milik-register="
                    rGedungBangunanTanahMilikRegister.value
                  "
                  :data-gedung-bangunan-tanah-milik-register="
                    dataGedungBangunanTanahMilikRegister
                  "
                >
                  <template v-slot:gedungBangunanTanahMilikKeterangan>
                    <b-form-input v-model="gedungBangunanTanahMilikKeterangan" />
                  </template>
                  <template v-slot:gedungBangunanTanahMilikSebutkan>
                    <b-form-input v-model="gedungBangunanTanahMilikSebutkan" />
                  </template>
                </V5GedungdanBangunanDiatasTanahMilik>
                <V6IndikasiTercatatGanda
                  v-if="
                    rIsIndikasiGanda == 1 &&
                      (rIndikasiGandaDengan === '1' ||
                        rIndikasiGandaDengan === '2')
                  "
                  :is-indikasi-ganda="rIsIndikasiGanda"
                  :indikasi-ganda-dengan="rIndikasiGandaDengan"
                >
                  <b-form-input v-model="indikasiGandaSebutkan" />
                </V6IndikasiTercatatGanda>
                <V7IndikasiTercatatGabungan
                  v-if="rIndikasiGabungan == '1'"
                  :indikasi-gabungan="rIndikasiGabungan"
                >
                  <b-form-input v-model="indikasiGabunganKeterangan" />
                </V7IndikasiTercatatGabungan>
                <V8SkPenggunaan
                  v-if="rSkPenggunaan === '1'"
                  :sk-penggunaan="rSkPenggunaan"
                >
                  <template v-slot:nomorSkPenggunaan>
                    <b-form-input v-model="nomorSkPenggunaan" />
                  </template>
                  <template v-slot:tahunSkPenggunaan>
                    <b-form-input v-model="tahunSkPenggunaan" />
                  </template>
                </V8SkPenggunaan>
                <V9Penggunaan
                  v-if="rPenggunaan != '1'"
                  :penggunaan="rPenggunaan"
                >
                  <template>
                    <b-form-input
                      v-if="rPenggunaan === '2'"
                      v-model="digunakanUntuk[0].value"
                    />
                    <div
                      v-for="(item, index) of rPdUkpd"
                      v-else-if="rPenggunaan === '3'"
                      :key="index"
                    >
                      <b-form-group
                        label="PD/UKPD"
                        label-for="pdUkpd"
                      >
                        <b-form-select
                          v-model="item.value.value"
                          :options="dataPdUkpd"
                          disabled
                        />
                      </b-form-group>

                      <b-col
                        cols="11"
                        offset-md="1"
                        class="mt-1 pr-0"
                      >
                        <b-form-group
                          label="Digunakan Untuk"
                          label-for="digunakanUntuk"
                        >
                          <b-form-input v-model="digunakanUntuk[index].value" />
                        </b-form-group>
                      </b-col>
                    </div>
                    <div v-else-if="rPenggunaan === '4'">
                      <b-form-checkbox
                        v-model="rDigunakanBersama"
                        value="1"
                        disabled
                      >PD/UKPD Lain</b-form-checkbox>
                      <b-col
                        v-if="rDigunakanBersama.includes('1')"
                        cols="11"
                        offset-md="1"
                        class="mt-1 pr-0"
                      >
                        <div
                          v-for="(item, index) of rPdUkpd"
                          :key="index"
                        >
                          <b-form-group
                            label="PD/UKPD"
                            label-for="pdUkpd"
                          >
                            <b-form-select
                              v-model="item.value.value"
                              :options="dataPdUkpd"
                              disabled
                            />
                          </b-form-group>
                          <b-col
                            cols="11"
                            offset-md="1"
                            class="mt-1 pr-0"
                          >
                            <b-form-group
                              label="Digunakan Untuk"
                              label-for="digunakanUntuk"
                            >
                              <b-form-input v-model="digunakanUntuk[index].value" />
                            </b-form-group>
                          </b-col>
                        </div>
                      </b-col>
                      <b-form-checkbox
                        v-model="rDigunakanBersama"
                        value="0"
                        disabled
                      >Instansi / Pihak Lain</b-form-checkbox>
                      <b-col
                        v-if="rDigunakanBersama.includes('0')"
                        cols="11"
                        offset-md="1"
                        class="mt-1 pr-0"
                      >
                        <div
                          v-for="(item, indexx) of rPemanfaat"
                          :key="indexx + 'i'"
                        >
                          <b-form-group
                            label="Pemanfaat"
                            label-for="pemanfaat"
                          >
                            <b-form-select
                              v-model="item.value"
                              :options="dataPemanfaat"
                              disabled
                            />
                          </b-form-group>
                          <b-col
                            cols="11"
                            offset-md="1"
                            class="mt-1 pr-0"
                          >
                            {{ pemanfaat }}
                            <div v-if="rPemanfaat[indexx].value === '1' || rPemanfaat[indexx].value === '2'">
                              <b-form-group
                                label="Nama Pemanfaat"
                                label-for="namaPemanfaat"
                              >
                                <b-form-input v-model="pemanfaat[indexx].namaPemanfaat" />
                              </b-form-group>
                              <b-form-group
                                label="Dasar Penggunaan"
                                label-for="dasarPenggunaan"
                              >
                                <b-form-radio
                                  v-model="rPemanfaat[indexx].dasarPenggunaan"
                                  disabled
                                  value="1"
                                >Ada Pinjam Pakai</b-form-radio>
                                <b-form-radio
                                  v-model="rPemanfaat[indexx].dasarPenggunaan"
                                  disabled
                                  value="0"
                                >Tidak Ada Pinjam Pakai</b-form-radio>
                              </b-form-group>
                            </div>

                            <div v-if="rPemanfaat[indexx].value === '3'">
                              <b-form-group
                                label="Nama Pemanfaat"
                                label-for="namaPemanfaat"
                              >
                                <b-form-input v-model="pemanfaat[indexx].namaPemanfaat" />
                              </b-form-group>
                              <b-form-group label="Dasar Penggunaan">
                                <b-form-radio
                                  v-model="rPemanfaat[indexx].dasarPenggunaan"
                                  disabled
                                  value="1"
                                >Ada Dasar Penggunaan</b-form-radio>
                                <b-col
                                  v-if="
                                    rPemanfaat[indexx].dasarPenggunaan === '1'
                                  "
                                  cols="11"
                                  offset-md="1"
                                >
                                  <b-form-radio
                                    v-model="
                                      rPemanfaat[indexx].dasarPenggunaanTipe
                                    "
                                    disabled
                                    value="6"
                                  >Sewa</b-form-radio>
                                  <b-form-radio
                                    v-model="
                                      rPemanfaat[indexx].dasarPenggunaanTipe
                                    "
                                    disabled
                                    value="5"
                                  >Pinjam Pakai</b-form-radio>
                                  <b-form-radio
                                    v-model="
                                      rPemanfaat[indexx].dasarPenggunaanTipe
                                    "
                                    disabled
                                    value="3"
                                  >Bangun Guna Serah</b-form-radio>
                                  <b-form-radio
                                    v-model="
                                      rPemanfaat[indexx].dasarPenggunaanTipe
                                    "
                                    disabled
                                    value="4"
                                  >Bangun Serah Guna</b-form-radio>
                                  <b-form-radio
                                    v-model="
                                      rPemanfaat[indexx].dasarPenggunaanTipe
                                    "
                                    disabled
                                    value="7"
                                  >KSP (Kerjasama Pemanfaatan)</b-form-radio>
                                  <b-form-radio
                                    v-model="
                                      rPemanfaat[indexx].dasarPenggunaanTipe
                                    "
                                    disabled
                                    value="1"
                                  >KSPI</b-form-radio>
                                </b-col>

                                <b-form-radio
                                  v-model="rPemanfaat[indexx].dasarPenggunaan"
                                  disabled
                                  value="0"
                                >Tidak Ada Dasar Penggunaan</b-form-radio>
                              </b-form-group>
                            </div>
                          </b-col>
                        </div>
                      </b-col>
                    </div>
                    <div
                      v-for="(item, indexx) of rPemanfaat"
                      v-else-if="rPenggunaan === '5'"
                      :key="indexx + 'i'"
                    >
                      <b-form-group
                        label="Pemanfaat"
                        label-for="pemanfaat"
                      >
                        <b-form-select
                          v-model="item.value"
                          :options="dataPemanfaat"
                          disabled
                        />
                      </b-form-group>
                      <b-col
                        cols="11"
                        offset-md="1"
                        class="mt-1 pr-0"
                      >
                        <div v-if="rPemanfaat[indexx].value === '1' || rPemanfaat[indexx].value === '2'">
                          <b-form-group
                            label="Nama Pemanfaat"
                            label-for="namaPemanfaat"
                          >
                            <b-form-input v-model="pemanfaat[indexx].namaPemanfaat" />
                          </b-form-group>
                          <b-form-group
                            label="Dasar Penggunaan"
                            label-for="dasarPenggunaan"
                          >
                            <b-form-radio
                              v-model="rPemanfaat[indexx].dasarPenggunaan"
                              disabled
                              value="1"
                            >Ada Pinjam Pakai</b-form-radio>
                            <b-form-radio
                              v-model="rPemanfaat[indexx].dasarPenggunaan"
                              disabled
                              value="0"
                            >Tidak Ada Pinjam Pakai</b-form-radio>
                          </b-form-group>
                        </div>

                        <div v-if="rPemanfaat[indexx].value === '3'">
                          <b-form-group
                            label="Nama Pemanfaat"
                            label-for="namaPemanfaat"
                          >
                            <b-form-input v-model="pemanfaat[indexx].namaPemanfaat" />
                          </b-form-group>
                          <b-form-group label="Dasar Penggunaan">
                            <b-form-radio
                              v-model="rPemanfaat[indexx].dasarPenggunaan"
                              disabled
                              value="1"
                            >Ada Dasar Penggunaan</b-form-radio>

                            <b-col
                              v-if="rPemanfaat[indexx].dasarPenggunaan === '1'"
                              cols="11"
                              offset-md="1"
                            >
                              <b-form-radio
                                v-model="rPemanfaat[indexx].dasarPenggunaanTipe"
                                disabled
                                value="6"
                              >Sewa</b-form-radio>
                              <b-form-radio
                                v-model="rPemanfaat[indexx].dasarPenggunaanTipe"
                                disabled
                                value="5"
                              >Pinjam Pakai</b-form-radio>
                              <b-form-radio
                                v-model="rPemanfaat[indexx].dasarPenggunaanTipe"
                                disabled
                                value="3"
                              >Bangun Guna Serah</b-form-radio>
                              <b-form-radio
                                v-model="rPemanfaat[indexx].dasarPenggunaanTipe"
                                disabled
                                value="4"
                              >Bangun Serah Guna</b-form-radio>
                              <b-form-radio
                                v-model="rPemanfaat[indexx].dasarPenggunaanTipe"
                                disabled
                                value="7"
                              >KSP (Kerjasama Pemanfaatan)</b-form-radio>
                              <b-form-radio
                                v-model="rPemanfaat[indexx].dasarPenggunaanTipe"
                                disabled
                                value="1"
                              >KSPI</b-form-radio>
                            </b-col>

                            <b-form-radio
                              v-model="rPemanfaat[indexx].dasarPenggunaan"
                              disabled
                              value="0"
                            >Tidak Ada Dasar Penggunaan</b-form-radio>
                          </b-form-group>
                        </div>
                      </b-col>
                    </div>
                  </template>
                </V9Penggunaan>
                <V11PotensiPemanfaatan
                  v-if="
                    rIsLantaiDigunakan == 1 ||
                      (rIsAtapBeton == 1 && rIsAtapBetonIsDigunakan == 1) ||
                      (rIsBasement == 1 && rIsBasementIsDigunakan == 1) ||
                      (rIsHalamanUtama == 1 && rIsHalamanUtamaIsDigunakan == 1)
                  "
                  :is-lantai-digunakan="rIsLantaiDigunakan"
                  :jumlah-seluruh-lantai="rJumlahSeluruhLantai"
                  :jumlah-lantai-digunakan="jumlahLantaiDigunakan"
                  :is-atap-beton="rIsAtapBeton"
                  :is-atap-beton-is-digunakan="rIsAtapBetonIsDigunakan"
                  :is-basement="rIsBasement"
                  :is-basement-is-digunakan="rIsBasementIsDigunakan"
                  :is-halaman-utama="rIsHalamanUtama"
                  :is-halaman-utama-is-digunakan="rIsHalamanUtamaIsDigunakan"
                >
                  <template v-slot:jumlahLantaiTidakDigunakan>
                    <cleave
                      v-model="jumlahLantaiTidakDigunakan"
                      class="form-control"
                      :options="{
                        ...ruleAngka,
                        numeralDecimalScale: 0,
                      }"
                      :disabled="
                        rIsBertingkat === '0' && rIsLantaiDigunakan === '1'
                      "
                      @keyup="keyUpLantai"
                    />
                  </template>
                  <template v-slot:atapBetonDigunakan>
                    <b-form-input v-model="atapBetonDigunakan" />
                  </template>
                  <template v-slot:basementDigunakan>
                    <b-form-input v-model="basementDigunakan" />
                  </template>
                  <template v-slot:halamanUtamaDigunakan>
                    <b-form-input v-model="halamanUtamaDigunakan" />
                  </template>
                </V11PotensiPemanfaatan>
                <V13PenguasaanFisik
                  v-if="
                    (rPengamananFisik === '1' && rFisikDikuasai === '0') ||
                      rPengamananFisik === '0'
                  "
                  :pengamanan-fisik="rPengamananFisik"
                  :fisik-dikuasai="rFisikDikuasai"
                >
                  <template v-slot:fisikDikuasaiSebutkan>
                    <b-form-input v-model="fisikDikuasaiSebutkan" />
                  </template>
                  <template v-slot:fisikTidakDikuasaiSebutkan>
                    <b-form-input v-model="fisikTidakDikuasaiSebutkan" />
                  </template>
                </V13PenguasaanFisik>
              </b-col>
              <b-col
                v-if="routeName == 'koreksiCleansingTambah'"
                cols="12"
                class="text-right pr-0 pt-2"
              >
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  type="button"
                  variant="primary"
                  @click="clickSubmit"
                >
                  <div v-if="isSubmit">
                    <b-spinner small />
                    <span class="sr-only">Loading...</span>
                  </div>
                  <div v-else>
                    Simpan
                  </div>
                </b-button>
              </b-col>
            </b-form-row>
          </b-overlay>
        </b-form>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BForm,
  BFormRow,
  BCol,
  BFormInput,
  BCardHeader,
  BCardBody,
  BButton,
  BFormGroup,
  BCardTitle,
  BSpinner,
  BFormSelect,
} from 'bootstrap-vue'
import { ref, watch, watchEffect } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import Cleave from 'vue-cleave-component'
import master from '@/composables/master'
import Field from '@/views/koreksi/component/field/Index.vue'
import { setInputIntOnly } from '@/libs/helper'
import cetakDaftarBmd from '@/composables/cetakDaftarBmd'
import apiCleansing from '@/composables/koreksi/cleansing'

export default {
  setup(props, context) {
    const g = context.root
    const routeName = g.$route.name

    const defaultVNull = { text: '-- Pilih Salah Satu --', value: null }
    const isSubmit = ref(false)

    // form cari
    const wilayah = ref('')
    const pdUpd = ref({ text: '-- Semua --', value: '' })
    const register = ref(defaultVNull)
    const status = ref(9)

    const dataWilayah = ref([])
    const dataPdUpd = ref([])
    const dataRegister = ref([])
    const dataStatus = ref([
      // { value: '7', text: 'Belum Cetak QR' },
      // { value: '8', text: 'Belum Scan QR dan Foto' },
      { value: '9', text: 'Selesai Inventarisasi' },
    ])
    const isLoadPdUpd = ref(false)
    const isLoadRegister = ref(false)

    // form name
    const isShowForm = ref(false)
    const rId = ref('')
    const jumlahLantaiDigunakan = ref('')
    const keteranganBetonSebutkan = ref(null)
    const peruntukkanPenggunaanBmd = ref(null)
    const sebabLain = ref(null)
    const ukuranSeharusnya = ref('')
    const namaSpesifikasiBarang = ref('')
    const jumlahLantaiTidakDigunakan = ref('')
    const nomorSkPenggunaan = ref('')
    const tahunSkPenggunaan = ref('')
    const digunakanUntuk = ref([])
    const pemanfaat = ref([
      {
        value: null,
        namaPemanfaat: '',
        dasarPenggunaan: '',
        dasarPenggunaanTipe: '',
      },
    ])
    const gedungBangunanTanahMilikKeterangan = ref('')
    const gedungBangunanTanahMilikSebutkan = ref('')
    const jalan = ref('')
    const noAlamat = ref('')
    const rt = ref('')
    const rw = ref('')
    const indikasiGandaSebutkan = ref('')
    const indikasiGabunganKeterangan = ref(null)
    const atapBetonDigunakan = ref('')
    const basementDigunakan = ref('')
    const halamanUtamaDigunakan = ref('')
    const fisikDikuasaiSebutkan = ref('')
    const tanda2BatasTanahUtara = ref('')
    const tanda2BatasTanahTimur = ref('')
    const tanda2BatasTanahSelatan = ref('')
    const tanda2BatasTanahBarat = ref('')
    const provinsi = ref('')

    ///
    const dataKib = ref([])
    const dataPdUkpd = ref([])
    const dataGedungBangunanTanahMilikRegister = ref([defaultVNull])
    const dataGedungBangunanTanahMilikKobar = ref([defaultVNull])
    const dataProvinsi = ref([defaultVNull])
    const dataKabKota = ref([defaultVNull])
    const dataKecamatan = ref([defaultVNull])
    const dataKelurahan = ref([defaultVNull])
    const dataKobar = ref([])

    const isShowInfo = ref(false)

    const getProvinsi = async () => {
      const resProvinsi = await master.getProvinsi(g)
      resProvinsi.unshift(defaultVNull)
      dataProvinsi.value = resProvinsi
    }

    const getKabKota = async idProvinsi => {
      const params = {
        provinsi: idProvinsi,
      }

      let resKota = await master.getKota(g, params)
      if (resKota) {
        resKota.unshift(defaultVNull)
      } else resKota = [defaultVNull]
      dataKabKota.value = resKota
    }

    const getKecamatan = async (idProvinsi, kota) => {
      const params = {
        provinsi: idProvinsi,
        kota,
      }
      let resKecamatan = await master.getKecamatan(g, params)
      if (resKecamatan) resKecamatan.unshift(defaultVNull)
      else resKecamatan = [defaultVNull]
      dataKecamatan.value = resKecamatan
    }

    const getKelurahan = async (idProvinsi, kota, kecamatan) => {
      const params = {
        provinsi: idProvinsi,
        kota,
        kecamatan,
      }
      let resKelurahan = await master.getKelurahan(g, params)
      if (resKelurahan) resKelurahan.unshift(defaultVNull)
      else resKelurahan = [defaultVNull]
      dataKelurahan.value = resKelurahan
    }

    watch(provinsi, () => {
      getProvinsi()
      getKabKota(props.rProvinsi)
      getKecamatan(props.rProvinsi, props.rKabKota)
      getKelurahan(props.rProvinsi, props.rKabKota, props.rKecamatan)
    })

    watchEffect(() => {
      isShowForm.value = props.isShowFormVal
      digunakanUntuk.value = props.digunakanUntukVal
      provinsi.value = props.rProvinsi
      jumlahLantaiDigunakan.value = props.rJumlahLantaiDigunakan

      jumlahLantaiDigunakan.value = props.jumlahLantaiDigunakanVal
      keteranganBetonSebutkan.value = props.keteranganBetonSebutkanVal
      peruntukkanPenggunaanBmd.value = props.peruntukkanPenggunaanBmdVal
      sebabLain.value = props.sebabLainVal
      ukuranSeharusnya.value = props.ukuranSeharusnyaVal
      namaSpesifikasiBarang.value = props.namaSpesifikasiBarangVal
      jumlahLantaiTidakDigunakan.value = props.jumlahLantaiTidakDigunakanVal
      nomorSkPenggunaan.value = props.nomorSkPenggunaanVal
      tahunSkPenggunaan.value = props.tahunSkPenggunaanVal
      digunakanUntuk.value = props.digunakanUntukVal
      pemanfaat.value = props.pemanfaatVal
      gedungBangunanTanahMilikKeterangan.value = props.gedungBangunanTanahMilikKeteranganVal
      gedungBangunanTanahMilikSebutkan.value = props.gedungBangunanTanahMilikSebutkanVal
      jalan.value = props.jalanVal
      noAlamat.value = props.noAlamatVal
      rt.value = props.rtVal
      rw.value = props.rwVal
      indikasiGandaSebutkan.value = props.indikasiGandaSebutkanVal
      indikasiGabunganKeterangan.value = props.indikasiGabunganKeteranganVal
      atapBetonDigunakan.value = props.atapBetonDigunakanVal
      basementDigunakan.value = props.basementDigunakanVal
      halamanUtamaDigunakan.value = props.halamanUtamaDigunakanVal
      fisikDikuasaiSebutkan.value = props.fisikDikuasaiSebutkanVal
      tanda2BatasTanahUtara.value = props.tanda2batasTanahUtaraVal
      tanda2BatasTanahTimur.value = props.tanda2batasTanahTimurVal
      tanda2BatasTanahSelatan.value = props.tanda2batasTanahSelatanVal
      tanda2BatasTanahBarat.value = props.tanda2batasTanahBaratVal
    })

    // const getKobar = async (kibKobar, kobar = "", kolok = null) => {
    //   let params = {
    //     kib: kibKobar,
    //     cari: kobar,
    //     kolok,
    //     length: 100000,
    //   };

    //   return await master.getKobar(g, params);
    // };

    // const getNoReg = async (kib, rekonTahun, rekonKode, kolok, kobar) => {
    //   let params = {
    //     kib,
    //     tahun_rekon: rekonTahun,
    //     kode_rekon: rekonKode,
    //     kolok,
    //     kobar,
    //   };
    //   return await master.getNoReg(g, params);
    // };

    const submitForm = async () => {
      isSubmit.value = true

      // mapping data
      const data = {
        id_inven_pengguna: rId.value ? rId.value : props.rIdVal,
        di_nm_spesifikasi_barang: namaSpesifikasiBarang.value,
        di_jalan: jalan.value,
        di_no_jalan: noAlamat.value,
        di_rt: rt.value,
        di_rw: rw.value,
      }

      if (props.rKeberadaan == '1') {
        if (props.rKeteranganBeton == '0') data.dk_ket_beton_note = keteranganBetonSebutkan.value

        data.dk_peruntukan_bmd = peruntukkanPenggunaanBmd.value

        data.tbt_utara = tanda2BatasTanahUtara.value
        data.tbt_timur = tanda2BatasTanahTimur.value
        data.tbt_selatan = tanda2BatasTanahSelatan.value
        data.tbt_barat = tanda2BatasTanahBarat.value
      } else if (props.rKeberadaan.value == '0') {
        if (
          props.rAlasanTidakAdaP != '0'
          && props.rAlasanTidakAdaP != '1'
          && props.rAlasanTidakAdaP != '2'
          && props.rAlasanTidakAda != '13'
          && props.rAlasanTidakAda != '14'
          && props.rAlasanTidakAda != 11
          && props.rAlasanTidakAda == '5'
        ) data.alasan_tidak_ada_note = sebabLain.value
      }

      if (props.rKesesuaianUkuran == '0') data.di_m_ukuran_a = ukuranSeharusnya.value

      if (props.rIsLantaiDigunakan == '1') {
        data.di_m_lantai_tdk_not = jumlahLantaiTidakDigunakan.value
        data.di_m_lantai_tdk_use = jumlahLantaiDigunakan.value

        data.di_pp_lt_tidak_digunakan = jumlahLantaiTidakDigunakan.value
      }

      if (props.rSkPenggunaan == '1') {
        data.di_sk_penggunaan_no = nomorSkPenggunaan.value
        data.di_sk_penggunaan_tahun = tahunSkPenggunaan.value
      }

      if (props.rPenggunaan === '2' || props.rPenggunaan === '3') data.di_penggunaan_untuk = [digunakanUntuk.value[0].value]

      if (props.rPenggunaan === '4') {
        if (props.rDigunakanBersama.includes('1')) {
          data.di_penggunaan_untuk = digunakanUntuk.value.map(item => item.value)
        }

        if (props.rDigunakanBersama.includes('0')) {
          data.di_penggunaan_pemanfaat_nama = pemanfaat.value.map(({ namaPemanfaat }) => namaPemanfaat)
        }
      }

      if (props.rPenggunaan === '5') {
        data.di_penggunaan_pemanfaat_nama = pemanfaat.value.map(({ namaPemanfaat }) => namaPemanfaat)
      }

      if (props.rGedungBangunanTanahMilik === '1') {
        if (props.rIsGedungBangunanTanahMilikTercatat == '0') {
          data.di_gedung_bangunan_diatas_tanah_milik_sebut = gedungBangunanTanahMilikKeterangan.value
        }
      } else if (
        props.rGedungBangunanTanahMilik === '2'
        || props.rGedungBangunanTanahMilik === '3'
        || props.rGedungBangunanTanahMilik === '4'
      ) data.di_gedung_bangunan_diatas_tanah_milik_sebut = gedungBangunanTanahMilikSebutkan.value

      if (props.rIsIndikasiGanda == '1') {
        if (props.rIndikasiGandaDengan === '1' || props.rIndikasiGandaDengan === '2') {
          data.di_indikasi_ganda_sebutkan = indikasiGandaSebutkan.value
        }
      }

      if (props.rIndikasiGabungan == '1') data.di_indikasi_gabungan_keterangan = indikasiGabunganKeterangan.value

      if (props.rIsAtapBeton === '1' && props.rIsAtapBetonIsDigunakan === '1') data.di_pp_at_ada_digunakan_oleh = atapBetonDigunakan.value

      if (props.rIsBasement === '1' && props.rIsBasementIsDigunakan === '1') data.di_pp_bm_ada_digunakan_oleh = basementDigunakan.value

      if (props.rIsHalamanUtama === '1' && props.rIsHalamanUtamaIsDigunakan === '1') data.di_pp_ht_ada_digunakan_oleh = halamanUtamaDigunakan.value

      if (props.rPengamananFisik === '1' && props.rFisikDikuasai === '0') data.di_pengamanan_fisik_note = fisikDikuasaiSebutkan.value
      try {
        await apiCleansing.submit(g, data)
      } catch (error) {
        console.log(error)
      }
      isSubmit.value = false
    }

    const getPdUkpd = async () => {
      const params = {
        wilayah: wilayah.value,
      }
      const resPdUkpd = await master.getPdUpd(g, params)
      return resPdUkpd
    }

    const validateState = item => {
      const { $error } = item
      let result = null
      if ($error) result = false
      return result
    }

    const keyUpLantai = () => {
      if (props.rIsBertingkat === '0' && props.rIsLantaiDigunakan === '1') jumlahLantaiTidakDigunakan.value = 1

      jumlahLantaiDigunakan.value = (
        props.rJumlahSeluruhLantai - jumlahLantaiTidakDigunakan.value
      ).toString()
    }

    const changeIntOnly = evt => {
      setInputIntOnly(evt)
    }

    const getWilayah = async () => {
      const resWilayah = await master.getWilayah(g)
      resWilayah.unshift({ text: '-- Semua --', value: '' })

      dataWilayah.value = resWilayah
    }

    const getRegister = async (search = '') => {
      const params = {
        filter_upd: pdUpd.value.value,
        length: 20,
        start: 0,
        filter_status: status.value,
        username: g.$cookies.get('username'),
        cari: search,
      }
      const resBmd = await cetakDaftarBmd.getBmd(g, params)
      const { code, list } = resBmd

      dataRegister.value = code == 200
        ? list.map(({
          ALAMAT, HARGA, UKU_SAT, guid_aset: guidAset, id,
        }) => ({
          text: `${ALAMAT} :: ${HARGA} :: ${UKU_SAT} :: ${guidAset}`,
          value: id,
        }))
        : []
    }

    const inputPdUpd = async () => {
      isLoadRegister.value = true
      register.value = defaultVNull
      isShowForm.value = false
      getRegister()
      isLoadRegister.value = false
    }

    const changeWilayah = async () => {
      isLoadPdUpd.value = true
      pdUpd.value = { text: '-- Semua --', value: '' }
      register.value = defaultVNull
      isShowForm.value = false
      const resPdUkpd = await getPdUkpd()
      isLoadPdUpd.value = false
      resPdUkpd.unshift({ text: '-- Semua --', value: '' })
      dataRegister.value = [defaultVNull]
      dataPdUpd.value = resPdUkpd
      getRegister()
    }

    const inputRegister = async () => {
      rId.value = register.value.value
      context.emit('emitInputRegister', register.value)
    }

    const changeStatus = () => {
      if (pdUpd.value.value) inputPdUpd()
    }

    const getAllPdUpd = async () => {
      const resPdUkpd = await getPdUkpd()
      resPdUkpd.unshift(defaultVNull)
      dataPdUkpd.value = resPdUkpd
    }

    const searchRegister = async search => {
      if (search) await getRegister(search)
    }

    const clickSubmit = () => {
      g.$swal({
        title: 'Apakah anda yakin?',
        // text: 'Ya, Simpan',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Ya, Simpan',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          g.$swal({
            icon: 'success',
            title: 'Tersimpan!',
            text: 'Data telah tersimpan.',
            customClass: {
              confirmButton: 'btn btn-success',
            },
          })
          submitForm()
        }
      })
    }

    getWilayah()
    getAllPdUpd()
    getRegister()
    changeWilayah()

    const resetForm = () => { }

    return {
      routeName,
      isSubmit,
      isShowInfo,
      // form cari
      wilayah,
      pdUpd,
      register,
      status,

      dataWilayah,
      dataPdUpd,
      dataRegister,
      dataStatus,
      isLoadPdUpd,
      isLoadRegister,
      // form submit
      isShowForm,
      jumlahLantaiDigunakan,
      keteranganBetonSebutkan,
      peruntukkanPenggunaanBmd,
      sebabLain,
      ukuranSeharusnya,
      namaSpesifikasiBarang,
      jumlahLantaiTidakDigunakan,
      nomorSkPenggunaan,
      tahunSkPenggunaan,
      digunakanUntuk,
      pemanfaat,
      gedungBangunanTanahMilikKeterangan,
      gedungBangunanTanahMilikSebutkan,
      jalan,
      noAlamat,
      rt,
      rw,
      indikasiGandaSebutkan,
      indikasiGabunganKeterangan,
      atapBetonDigunakan,
      basementDigunakan,
      halamanUtamaDigunakan,
      fisikDikuasaiSebutkan,
      tanda2BatasTanahUtara,
      tanda2BatasTanahTimur,
      tanda2BatasTanahSelatan,
      tanda2BatasTanahBarat,
      dataKib,
      dataPdUkpd,
      dataGedungBangunanTanahMilikRegister,
      dataProvinsi,
      dataKabKota,
      dataKecamatan,
      dataKelurahan,
      dataGedungBangunanTanahMilikKobar,
      dataKobar,
      changeWilayah,
      inputPdUpd,
      inputRegister,
      changeStatus,
      searchRegister,
      resetForm,
      validateState,
      submitForm,
      changeIntOnly,
      keyUpLantai,
      clickSubmit,
    }
  },
  directives: {
    Ripple,
  },
  components: {
    KodeLokasi: Field.KodeLokasi,
    Kib: Field.Kib,
    KodeBarang: Field.KodeBarang,
    NamaBarang: Field.NamaBarang,
    KodeRegisterBarang: Field.KodeRegisterBarang,
    NilaiPerolehan: Field.NilaiPerolehan,
    TanggalPerolehan: Field.TanggalPerolehan,
    Keberadaan: Field.Keberadaan,
    V2Ukuran: Field.V2Ukuran,
    V3NamaSpesifikasiBarang: Field.V3NamaSpesifikasiBarang,
    V4Alamat: Field.V4Alamat,
    V5GedungdanBangunanDiatasTanahMilik:
      Field.V5GedungdanBangunanDiatasTanahMilik,
    V6IndikasiTercatatGanda: Field.V6IndikasiTercatatGanda,
    V7IndikasiTercatatGabungan: Field.V7IndikasiTercatatGabungan,
    V8SkPenggunaan: Field.V8SkPenggunaan,
    V9Penggunaan: Field.V9Penggunaan,
    V11PotensiPemanfaatan: Field.V11PotensiPemanfaatan,
    V13PenguasaanFisik: Field.V13PenguasaanFisik,
    Cleave,
    vSelect,
    BCard,
    BForm,
    BFormRow,
    BCol,
    BFormInput,
    BCardHeader,
    BCardBody,
    BButton,
    BFormGroup,
    BCardTitle,
    BSpinner,
    BFormSelect,
  },
  props: {
    isShowFormVal: { type: Boolean, default: false },
    isLoadFormVal: { type: Boolean, default: false },
    rIdVal: { type: String, default: '' },
    rKolok: { type: String, default: '' },
    rKib: { type: String, default: '' },
    title: { type: String, default: '' },
    rKobar: { type: String, default: '' },
    rNabar: { type: String, default: '' },
    rKodeRegisterBarang: { type: String, default: '' },
    rNilaiPerolehan: { type: String, default: '' },
    rTahunPerolehan: { type: String, default: '' },
    rKeberadaan: { type: String, default: '' },
    rTanda2batasTanahUtara: { type: String, default: '' },
    rTanda2batasTanahTimur: { type: String, default: '' },
    rTanda2batasTanahSelatan: { type: String, default: '' },
    rTanda2batasTanahBarat: { type: String, default: '' },
    rAlasanTidakAda: { type: String, default: '' },
    rAlasanTidakAdaP: { type: String, default: '' },
    rSebabLain: { type: String, default: '' },
    rKeteranganBeton: { type: String, default: '' },
    rKeteranganBetonSebutkan: { type: String, default: '' },
    rPeruntukkanPenggunaanBmd: { type: String, default: '' },
    rUkuran: { type: String, default: '' },
    rSatuan: { type: String, default: '' },
    rKesesuaianUkuran: { type: String, default: '' },
    rSatuanSeharusnya: { type: String, default: '' },
    rUkuranSeharusnya: { type: String, default: '' },
    rNamaSpesifikasiBarang: { type: String, default: '' },
    rAlamat: { type: String, default: '' },
    rProvinsi: { type: String, default: '' },
    rKabKota: { type: String, default: '' },
    rKecamatan: { type: String, default: '' },
    rKelurahan: { type: String, default: '' },
    rKodePos: { type: String, default: '' },
    rJalan: { type: String, default: '' },
    rNoAlamat: { type: String, default: '' },
    rRt: { type: String, default: '' },
    rRw: { type: String, default: '' },
    rGedungBangunanTanahMilik: { type: String, default: '' },
    rIsGedungBangunanTanahMilikTercatat: { type: String, default: '' },
    rGedungBangunanTanahMilikPdUkpd: { type: Object, default: () => ({}) },
    rGedungBangunanTanahMilikKobar: { type: Object, default: () => ({}) },
    rGedungBangunanTanahMilikRegister: { type: Object, default: () => ({}) },
    rGedungBangunanTanahMilikKeterangan: { type: String, default: '' },
    rGedungBangunanTanahMilikSebutkan: { type: String, default: '' },
    rIsIndikasiGanda: { type: String, default: '' },
    rIndikasiGandaDengan: { type: String, default: '' },
    rIndikasiGandaSebutkan: { type: String, default: '' },
    rIndikasiGabungan: { type: String, default: '' },
    rIndikasiGabunganKeterangan: { type: String, default: '' },
    rSkPenggunaan: { type: String, default: '' },
    rNomorSkPenggunaan: { type: String, default: '' },
    rTahunSkPenggunaan: { type: String, default: '' },
    rPenggunaan: { type: String, default: '' },
    rDigunakanBersama: { type: Array, default: () => [] },
    rPdUkpd: { type: Array, default: () => [] },
    rDigunakanUntuk: { type: Array, default: () => [] },
    rPemanfaat: { type: Array, default: () => [] },
    rIsLantaiDigunakan: { type: String, default: '' },
    rJumlahSeluruhLantai: { type: String, default: '' },
    rJumlahLantaiDigunakan: { type: String, default: '' },
    rIsAtapBeton: { type: String, default: '' },
    rIsAtapBetonIsDigunakan: { type: String, default: '' },
    rIsBasement: { type: String, default: '' },
    rIsBasementIsDigunakan: { type: String, default: '' },
    rIsHalamanUtama: { type: String, default: '' },
    rIsHalamanUtamaIsDigunakan: { type: String, default: '' },
    rJumlahLantaiTidakDigunakan: { type: String, default: '' },
    rAtapBetonDigunakan: { type: String, default: '' },
    rBasementDigunakan: { type: String, default: '' },
    rHalamanUtamaDigunakan: { type: String, default: '' },
    rIsBertingkat: { type: String, default: '' },
    rPengamananFisik: { type: String, default: '' },
    rFisikDikuasai: { type: String, default: '' },
    rFisikDikuasaiSebutkan: { type: String, default: '' },
    rFisikTidakDikuasaiSebutkan: { type: String, default: '' },
    jumlahLantaiDigunakanVal: { type: String, default: '' },
    keteranganBetonSebutkanVal: { type: String, default: '' },
    peruntukkanPenggunaanBmdVal: { type: String, default: '' },
    sebabLainVal: { type: String, default: '' },
    ukuranSeharusnyaVal: { type: String, default: '' },
    namaSpesifikasiBarangVal: { type: String, default: '' },
    jumlahLantaiTidakDigunakanVal: { type: String, default: '' },
    nomorSkPenggunaanVal: { type: String, default: '' },
    tahunSkPenggunaanVal: { type: String, default: '' },
    digunakanUntukVal: { type: Array, default: () => [] },
    pemanfaatVal: { type: Array, default: () => [] },
    gedungBangunanTanahMilikKeteranganVal: { type: String, default: '' },
    gedungBangunanTanahMilikSebutkanVal: { type: String, default: '' },
    jalanVal: { type: String, default: '' },
    noAlamatVal: { type: String, default: '' },
    rtVal: { type: String, default: '' },
    rwVal: { type: String, default: '' },
    indikasiGandaSebutkanVal: { type: String, default: '' },
    indikasiGabunganKeteranganVal: { type: String, default: '' },
    atapBetonDigunakanVal: { type: String, default: '' },
    basementDigunakanVal: { type: String, default: '' },
    halamanUtamaDigunakanVal: { type: String, default: '' },
    fisikDikuasaiSebutkanVal: { type: String, default: '' },
    tanda2batasTanahUtaraVal: { type: String, default: '' },
    tanda2batasTanahTimurVal: { type: String, default: '' },
    tanda2batasTanahSelatanVal: { type: String, default: '' },
    tanda2batasTanahBaratVal: { type: String, default: '' },
  },
  data() {
    return {
      dataPemanfaat: [
        { value: null, text: '-- Pilih Salah Satu --' },
        { value: '1', text: 'Pemerintah Pusat' },
        { value: '2', text: 'Pemerintah Daerah Lainnya' },
        { value: '3', text: 'Pihak Lain Selain Pemerintah' },
      ],
      ruleAngka: {
        numeral: true,
        numeralDecimalMark: ',',
        delimiter: '.',
      },
    }
  },
}
</script>

<style lang="scss" scope>
@import "@core/scss/vue/libs/vue-select.scss";
</style>
